<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Tambah Pesanan</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Ubah</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Hapus</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Ekspor
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Tutup
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6" class="pr-5">
          <b-input-group>
            <b-input-group-prepend>
              <label>Agen/Langganan</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.codenama"
              @keyup.13.native="lkuKoranCustShow=true"
              placeholder="Kode atau Nama"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCustShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Periode</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">s.d</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">

          <b-input-group>
            <b-input-group-prepend>
              <label>Sales(AE) | Kolektor</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.salesae_codename" placeholder="Sales (AE)"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranSalesShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-form-input v-model="tblData.collector_codename" placeholder="Kolektor" class="ml-2"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCollectShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Jenis Kiriman</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.kiriman_code" placeholder="Jenis Kiriman"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuKoranKirimanCodeShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-button class="btn btn-success ml-3 mr-1" @click="refresh()">
              <i class="fa fa-refresh"></i> Terapkan Filter
            </b-button>
            <b-button class="btn btn-secondary" @click="clearFilter()">
              <i class="fa fa-eraser"></i> Hapus Filter
            </b-button>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:cell(CustName)="data">{{data.item.CustCode+" | "+ data.item.CustName }}</template>

        <template v-slot:cell(Address)="data">
          {{ data.item.Address1 }}
          {{ data.item.Address2 }}
        </template>
        <template v-slot:cell(PhoneNo)="data">
          <span v-if="(data.item.PhoneNo)">P.{{data.item.PhoneNo}}</span>&nbsp;
          <span v-if="(data.item.FaxNo)">F.{{data.item.FaxNo}}</span>
        </template>
        <template v-slot:cell(isprabayar)="data">
          <span>{{data.item.isprabayar === 1?'Ya':''}}</span>
        </template>
        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label="Limit per page" class="mb-0">
            <b-form-select
              :options="tblData.pageOptions"
              :plain="true"
              v-model="tblData.limit"
              @change="refresh"
              style="width:80px;"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-modal
      v-model="lkuKoranCustShow"
      size="lg"
      :hide-footer="true"
      title="List of Agen/Langganan"
      :centered="true"
    >
      <lku-customerkoran @click="onSelectKoranCust"></lku-customerkoran>
    </b-modal>
    <b-modal
      v-model="lkuKoranSalesShow"
      size="lg"
      :hide-footer="true"
      title="List Sales"
      :centered="true"
    >
      <lku-salesae @click="onSelectKoranSales" crudfilter="koran=1"></lku-salesae>
    </b-modal>
    <b-modal
      v-model="lkuKoranCollectShow"
      size="lg"
      :hide-footer="true"
      title="List Kolektor"
      :centered="true"
    >
      <lku-collector @click="onSelectKoranCollect"></lku-collector>
    </b-modal>
    <b-modal
      v-model="lkuKoranKirimanCodeShow"
      size="md"
      :hide-footer="true"
      title="Jenis Kiriman"
      :centered="true"
    >
      <lku-koranjeniskiriman @click="onSelectKoranJenisKiriman"></lku-koranjeniskiriman>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import koran_pesanan from "../../apis/koran_pesanan_periode";
import lkuCustomerkoran from "../lookup/lkuKoranCust";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuCollector from "../lookup/lkuCollector";
import lkuKoranjeniskiriman from "../lookup/lkuKoranJenisKiriman";

import toastr from "mini-toastr";
import moment from "moment";
toastr.init();

export default {
  components: {
    Loading,
    lkuCustomerkoran,
    lkuSalesae,
    lkuCollector,
    lkuKoranjeniskiriman
  },
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showFilter: false,
      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      terpilih: { customer_id: "" },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        pageOptions: [10, 20, 30, 50, 70, 90, 120],
        sortBy: null,
        sortDesc: false,
        koran: "1"
      },
      tgl1: null,
      tgl2: null,
      invdate: null,
      lkuKoranCustShow: false,
      lkuKoranSalesShow: false,
      lkuKoranCollectShow: false,
      lkuKoranKirimanCodeShow: false
    };
  },
  computed: {
    tblFields() {
      const fields = [
        // {
        //   key: "CustCode",
        //   thStyle: "width:100px",
        //   label: "Kode Agen",
        //   sortable: true
        // },
        {
          key: "CustName",
          thStyle: "width:200px",
          label: "Nama Agen",
          sortable: true
        },

        {
          key: "Address",
          label: "Alamat Penagihan"
        },
        {
          key: "City",
          label: "Kota",
          sortable: true
        },
        {
          key: "PhoneNo",
          label: "Phone/Fax",
          thStyle: "width:150px"
        },
        {
          key: "kiriman_code",
          label: "Kode Kiriman",
          thStyle: "width:150px",
          sortable: true
        },
        {
          key: "startdate",
          label: "Tanggal Mulai",
          sortable: true
        },
        {
          key: "jumlahHari",
          label: "Jml.Hari",
          sortable: true
        },
        {
          key: "enddate",
          thStyle: "width:100px",
          label: "Est.Tgl Akhir",
          sortable: true
        },
        {
          key: "kirimharian",
          label: "Kiriman Harian",
          thStyle: "width:150px",
          sortable: true
        },
        {
          key: "isprabayar",
          label: "Pra Bayar",
          sortable: true
        },
        {
          key: "salesae_name",
          label: "Sales (AE)",
          sortable: true
        }
      ];
      return fields;
    }
  },
  watch: {
    tgl1(val) {
      if (val !== null) this.tblData.tgl1 = moment(val).format("YYYY-MM-DD");
      else this.tblData.tgl1 = null;
    },
    tgl2(val) {
      if (val !== null) this.tblData.tgl2 = moment(val).format("YYYY-MM-DD");
      else this.tblData.tgl2 = null;
    },
    invdate(val) {
      if (val !== null) this.tblData.invdate = moment(val).format("YYYY-MM-DD");
      else this.tblData.invdate = null;
    }
  },
  created: async function() {},
  methods: {
    onSelectKoranCust: function(_selected) {
      this.tblData.codenama = _selected.CustCode;
      this.lkuKoranCustShow = false;
    },
    onSelectKoranSales: function(_selected) {
      this.tblData.salesae_codename = _selected.crewnik;
      this.lkuKoranSalesShow = false;
    },
    onSelectKoranCollect: function(_selected) {
      this.tblData.collector_codename = _selected.crewnik;
      this.lkuKoranCollectShow = false;
    },
    onSelectKoranJenisKiriman: function(_selected) {
      this.tblData.kiriman_code = _selected.kiriman_code;
      this.lkuKoranKirimanCodeShow = false;
    },
    formatDate(val) {
      if (val !== "") {
        let date = new Date(val);
        return moment(date).format("DD MMMM YYYY");
      } else {
        return null;
      }
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.isLoading = true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await koran_pesanan.list(this.tblData);
      list.forEach((el, idx) => {
        list[idx].startdate = moment(el.startdate).format("YYYY-MM-DD");
        list[idx].enddate = moment(el.enddate).format("YYYY-MM-DD");
      });
      this.isLoading = false;
      console.log("list", list);
      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.codenama = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.invdate = null;
      this.tblData.invoiceno = null;
      this.tblData.kiriman_code = "";
      this.tblData.salesae_codename = null;
      this.tblData.collector_codename = null;
      this.refresh();
    },
    add: function() {
      router.push({ name: "koran.pesananperiodefrm" });
    },
    edit: function() {
      if (this.terpilih.tablekey) {
        router.push({
          name: "koran.pesananperiodefrm",
          params: { tablekey: this.terpilih.tablekey }
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.terpilih.customer_id) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Deleted!");
      }
    },
    deleteData: async function() {
      try {
        await koran_pesanan.remove(this.terpilih);
        toastr.success("Delete record successfully");
        this.refresh();
      } catch (error) {
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    rowClicked(record, index) {
      if (this.terpilih.customer_id == record.customer_id) {
        this.edit();
      } else {
        if (this.terpilih && this.terpilih._rowVariant) {
          delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant = "info";
        this.$forceUpdate();
      }
    },

    exportxls: async function() {
      this.isLoading = true;
      try {
        const response = await koran_pesanan.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push("/koran/home");
    }
  }
};
</script>